import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { scrollPanelFieldsToTop, sortDDLByLabel, useNavigateToLogout } from "../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { DDLDataTable } from "../DDLDataTable";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { PayrollService } from "../../services/PayrollService";
import { TImeSheetCategoryTrackingFieldsPanel } from "./Panels/TImeSheetCategoryTrackingFieldsPanel";
import { TimeSheetCategoryTrackingFieldsTable } from "./TimeSheetCategoryTrackingFieldsTable/TimeSheetCategoryTrackingFieldsTable";
import { TimeSheetCategoryTrackingSetupValidationSchema } from "./validator";
import { TimeSheetCategoryTrackingToolbar } from "./TimeSheetCategoryTrackingToolbar";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";




export interface ITimeSheetCategoryTracking { }
const SINGLE_RECORD_DATA_QUERY_KEY = "time-sheet-category-tracking-single-data-record";
const TIMESHEET_CATEGORY_TRACKING_DATA_QUERY_KEY = "time-sheet-category-tracking-list";
const SELECT_CATEGORY_DLL = "select-category-ddl";

const useGetDataTimeSheetCategoryTracking = (
	// clientId: string,
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id, navigateToLogout],
		queryFn: () => {
			return PayrollService.getTimeSheetCategoryTrackingById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useTimeSheetCategoryTracking = (
	clientId: string,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [TIMESHEET_CATEGORY_TRACKING_DATA_QUERY_KEY, params],
		queryFn: (data) => {

			return PayrollService.getTimeSheetCategoryTracking(
				clientId,
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetSelectCategoryDDL = (clientId: string) =>
	useQuery({
		queryKey: [SELECT_CATEGORY_DLL],
		queryFn: () => {
			return PayrollService.getSelectCategoryDDL(
				clientId,
			);
		},
		refetchOnWindowFocus: false,
	});

export let categoryTrackingItemsInitialData = [
	{
		id: "1",
		categoryTrackingLabel: null,
		addJobsProjectToTrack: null,
	},
	{
		id: "2",
		categoryTrackingLabel: null,
		addJobsProjectToTrack: null,
	},
	{
		id: "3",
		categoryTrackingLabel: null,
		addJobsProjectToTrack: null,
	},
	{
		id: "4",
		categoryTrackingLabel: null,
		addJobsProjectToTrack: null,
	},
	{
		id: "5",
		categoryTrackingLabel: null,
		addJobsProjectToTrack: null,
	},
	{
		id: "6",
		categoryTrackingLabel: null,
		addJobsProjectToTrack: null,
	},
	{
		id: "7",
		categoryTrackingLabel: null,
		addJobsProjectToTrack: null,
	},
	{
		id: "8",
		categoryTrackingLabel: null,
		addJobsProjectToTrack: null,
	},
	{
		id: "9",
		categoryTrackingLabel: null,
		addJobsProjectToTrack: null,
	},
	{
		id: "10",
		categoryTrackingLabel: null,
		addJobsProjectToTrack: null,
	},
];

export const TimeSheetCategoryTracking: React.FC<ITimeSheetCategoryTracking> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [timeSheetCategoryTrackingId, setTimeSheetCategoryTrackingId] = useState();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	const [categoryTrackingTableUpdatedData, setCategoryTrackingTableUpdatedData] =
		useState(categoryTrackingItemsInitialData);
	const [categoryTrackingFieldsDataItems, setCategoryTrackingFieldsDataItems] =
		useState(categoryTrackingItemsInitialData);
	const [categoryId, setCategoryId] =
		useState();

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "category",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "category",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending: isPendingSelecteCategoryDDL, data: selecteCategoryDDL } =
		useGetSelectCategoryDDL(clientId);

	const { isPending, data } = useTimeSheetCategoryTracking(
		clientId,
		queryParams,
		navigateToLogout
	);

	console.log("selecteCategoryDDLselecteCategoryDDL", selecteCategoryDDL)
	const timeSheetCategoryTrackingList: any | null = data;
	console.log("timeSheetCategoryTrackingList", timeSheetCategoryTrackingList)


	const { isPending: isSubmitting, mutate: submitTimeSheetCategoryTrackingFormFields } =
		useMutation({
			mutationFn: PayrollService.createTimeSheetCategoryTracking,
			onSuccess: (res: ITimeSheetCategoryTracking | IServerError | IResponse | any) => {

				if (res.status === 200) {

					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					scrollPanelFieldsToTop()
					let path = `/settings/timesheet/category-tracking/${res.data.id}`;
					navigate(path);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [TIMESHEET_CATEGORY_TRACKING_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else if (res.status === 201) {

					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					scrollPanelFieldsToTop()
					let path = `/settings/timesheet/category-tracking/${res.data.id}`;
					navigate(path);
					setEditRecordId(res.data.id);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [TIMESHEET_CATEGORY_TRACKING_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {

				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isPendingById, data: selectedDataRecord } = useGetDataTimeSheetCategoryTracking(
		// clientId,
		editRecordId,
		navigateToLogout
	);

	const updatedTimeSheetCategoryTrackingListItems = useMemo(() => {
		return (
			timeSheetCategoryTrackingList &&
			timeSheetCategoryTrackingList.items &&
			timeSheetCategoryTrackingList?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/settings/timesheet/category-tracking/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{item.categoriesTrack}
					</Link>
				),
			}))
		);
	}, [timeSheetCategoryTrackingList]);

	const formMethods = useForm<any>({
		resolver: yupResolver(TimeSheetCategoryTrackingSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",

	});

	const onSubmit = (values: any) => {
		const selectedCategory = selecteCategoryDDL?.find(
			(x: any) => x.value === values.selectCatgory
		);
		const formatCategoryTrackingItemsData =
			categoryTrackingTableUpdatedData &&
			categoryTrackingTableUpdatedData
				.filter((x: any) => x.addJobsProjectToTrack && x.addJobsProjectToTrack.trim() !== "")
				.map((x: any) => ({
					// ...x,
					addJobsProjectToTrack: x.addJobsProjectToTrack,
				})) || [];;
		console.log("Formatted Payload", formatCategoryTrackingItemsData);
		let payload = {
			clientId: clientId,
			categoryId: selectedCategory.categoryId,
			categoryLabel: selectedCategory.label,
			categories: formatCategoryTrackingItemsData,
			navigateToLogout: navigateToLogout,
		};
		console.log("values", values);
		console.log("Payload", payload);
		submitTimeSheetCategoryTrackingFormFields(payload);
	};

	useEffect(() => {
		if (clientId && selectedDataRecord) {
			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				// if (fieldName === "selectCatgory" && fieldValue) {
				// 	fieldValue.map((item: any) => {
				// 		formMethods.setValue(`${item.id}-selectCatgory`, item.label);
				// 	});
				// }
				if (fieldName === 'categories' && Array.isArray(fieldValue)) {
					setCategoryTrackingFieldsDataItems(fieldValue);
					setCategoryTrackingTableUpdatedData(fieldValue);
				}
			});
		}
	}, [clientId, selectedDataRecord]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteTimeSheetCategoryTrackingById } = useMutation({
		mutationFn: PayrollService.delTimeSheetCategoryTracking,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {

				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				formMethods.reset();
				scrollPanelFieldsToTop()
				let path = `/settings/timesheet/category-tracking`;
				navigate(path);
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			return queryClient.invalidateQueries({
				queryKey: [TIMESHEET_CATEGORY_TRACKING_DATA_QUERY_KEY],
			});
		},
		onError: () => {

			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	console.log("timeSheetCategoryTrackingIdtimeSheetCategoryTrackingId", timeSheetCategoryTrackingId)
	const deleteTimeSheetCategoryTrackingField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				category: timeSheetCategoryTrackingId,
				navigateToLogout: navigateToLogout,
			};
			deleteTimeSheetCategoryTrackingById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setTimeSheetCategoryTrackingId(selectedDataRecord.id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setTimeSheetCategoryTrackingId(params);
	}, []);


	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		scrollPanelFieldsToTop()
		setCategoryTrackingFieldsDataItems([...categoryTrackingItemsInitialData.map((item) => ({ ...item }))]);
		setCategoryTrackingTableUpdatedData([...categoryTrackingItemsInitialData.map((item) => ({ ...item }))]);
		let path = `/settings/timesheet/category-tracking`;
		navigate(path);
	};

	const expandedLabels = ["Settings", "Time Sheet"];
	const expandedTimeSheetCategoryTrackingSetupOrSetupItem = "Category Tracking"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Time Sheet" &&
				item.label === expandedTimeSheetCategoryTrackingSetupOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedTimeSheetCategoryTrackingSetupOrSetupItem && "/settings/timesheet/category-tracking",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onRowEditClicked = useCallback((params: ITimeSheetCategoryTracking | any) => {
		let path = `/settings/timesheet/category-tracking/${params.value}`;
		navigate(path);
	}, []);

	return (
		<Grid>
			<BackdropCircularProgress
				open={isSubmitting || isPendingById || isDeleting || isPendingSelecteCategoryDDL || isPending}
				testId="time-sheet-category-tracking-Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteTimeSheetCategoryTrackingField}
				cancelActionHandler={onCloseHandler}
				testId="time-sheet-category-tracking-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 4.5, lg: 4.5, xl: 4.5 }}>
							<SingleColumnLayout
								children={
									<StandardPanel
										title="Category Tracking"
										testId={`time-sheet-category-tracking`}
										// leftSpacing={1}
										// rightSpacing={1}
										showTitle={false}
										variant="outlined"
										topPadding={2}
									>
										<TImeSheetCategoryTrackingFieldsPanel
											selectCategoryDDL={selecteCategoryDDL && sortDDLByLabel(selecteCategoryDDL ?? [])}
										/>

										<TimeSheetCategoryTrackingFieldsTable
											categoryTrackingTableUpdatedData={(data: any) =>
												setCategoryTrackingTableUpdatedData(data)
											}
											categoryTrackingFieldsDataItems={categoryTrackingFieldsDataItems}
										/>
									</StandardPanel>
								}
								toolbar={
									<TimeSheetCategoryTrackingToolbar
										onResetClicked={onResetClicked}
										onDeleteClicked={onDeleteClicked}
										isSubmitting={false}
										id={id}
									/>
								}
								showFullDiaplay={true}
								toolbarPosition="bottom"
								testId="form-layout"
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 4.5, lg: 4.5, xl: 4.5 }}></Grid>
						<Grid
							size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
							sx={{ marginTop: "16px" }}
						>
							<DDLDataTable
								rows={
									timeSheetCategoryTrackingList && updatedTimeSheetCategoryTrackingListItems
										? updatedTimeSheetCategoryTrackingListItems
										: []
									// timeSheetCategoryTrackingList?.items ?? []
									// []
								}
								columns={[
									{ field: "label", headerName: "Category Tracking" },
									{ field: "categoryTitle", headerName: "Category" },
								]}
								showHeaderColumns={true}
								showPaginator={false}
								// onRowEditClicked={onRowEditClicked}
								onRowDeleteClicked={onRowDeleteClicked}
								isLoading={isPending}
								totalRecords={
									timeSheetCategoryTrackingList && timeSheetCategoryTrackingList.total
										? timeSheetCategoryTrackingList.total
										: 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"60vh"}
								showArchiveIcon={false}
								selectedId={selectedDataRecord && id && selectedDataRecord.id}
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
					</Grid>
				</form>
			</FormProvider>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"time-sheet-category-tracking-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
